//ceny bez DPH

export const BASE_BOX_PRICE = 81.81;
export const VAT = 0.21;

export const FRONTEND_API = 'https://5mu6k57rd6.execute-api.eu-central-1.amazonaws.com/master';
export const FRONTEND_API_CACHED = 'https://www.darkovakrabicka.cz/frontendnapi';

export const AWS_API_HELPERS = 'https://www.darkovakrabicka.cz/helperapi';
export const ZASILKOVNA_API_CZ = `https://s3.eu-central-1.amazonaws.com/darkovakrabicka-static/zasilkovna-branch-v3-cz.json`;
export const ZASILKOVNA_API_SK = `https://s3.eu-central-1.amazonaws.com/darkovakrabicka-static/zasilkovna-branch-v3-sk.json`;

export const countrySettings = {
    CZ: {
        countryTitle: 'Česká republika',
        languagePickerTitle: 'Česko / Kč',
        currency: 'CZK',
        locale: 'cs',
        country: 'CZ'
    },

    SK: {
        countryTitle: 'Slovensko',
        languagePickerTitle: 'Slovensko / EUR',
        currency: 'EUR',
        locale: 'sk',
        country: 'SK'
    }
};

export const freeShippingLimit = {
    CZK: 1500,
    EUR: 65
};

export const baseBoxPriceVat = {
    CZK: 99,
    EUR: 3.9
};
export const dobirkaPriceVat = {
    CZK: 29,
    EUR: 1
};

export const premiumMessagePriceVat = {
    CZK: 19,
    EUR: 1
};

export const BOX_DESIGNS = [
    {
        country: ['CZ', 'SK'],
        id: '5',
        title: {
            CZ: 'Černobílá',
            SK: 'Čiernobiela'
        },
        image: 'cernobila-krabicka',
        thumb: 'cernobila-krabicka-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard', 'large']
    },
    {
        country: ['CZ', 'SK'],
        id: '6',
        title: {
            CZ: 'Tyrkysová',
            SK: 'Tyrkysová'
        },
        image: 'tyrkysova-krabicka',
        thumb: 'tyrkysova-krabicka-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard']
    },
    /* {
         country: ['CZ', 'SK'],
         id: '16',
         title: {
             CZ: 'S Cupcaky',
             SK: 'S Cupcaky'
         },
         image: 'krabicka-s-cupcaky',
         thumb: 'krabicka-s-cupcaky-thumb',
         price: BASE_BOX_PRICE,
         size: ['standard']
     },*/
    {
        country: ['CZ', 'SK'],
        id: '8',
        title: {
            CZ: 'Se srdíčky',
            SK: 'So srdiečkami'
        },
        image: 'krabicka-se-srdicky',
        thumb: 'krabicka-se-srdicky-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard', 'large']
    },
    {
        country: ['CZ', 'SK'],
        id: '20',
        title: {
            CZ: 'Miluju tě',
            SK: 'Miluju tě'
        },
        image: 'krabicka-miluji-te',
        thumb: 'krabicka-miluji-te-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard']
    },

    {
        country: ['CZ'],
        id: '14',
        title: {
            CZ: 'Mamince',
            SK: 'Mamince'
        },
        image: 'krabicka-mamince',
        thumb: 'krabicka-mamince-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard']
    },
    {
        country: ['SK'],
        id: '15',
        title: {
            CZ: 'Mamičke',
            SK: 'Mamičke'
        },
        image: 'krabicka-mamicke',
        thumb: 'krabicka-mamicke-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard']
    },

    {
        country: ['CZ', 'SK'],
        id: '21',
        title: {
            CZ: 'Mám Tě ráda',
            SK: 'Mám Ťa rada'
        },
        image: 'krabicka-mam-te-rada',
        thumb: 'krabicka-mam-te-rada',
        price: BASE_BOX_PRICE,
        size: ['standard']
    },

    {
        country: ['CZ', 'SK'],
        id: '13',
        title: {
            CZ: 'Modrá',
            SK: 'Modrá'
        },
        image: 'krabicka-modra',
        thumb: 'krabicka-modra-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard', 'large']
    },

    {
        country: ['CZ', 'SK'],
        id: '10',
        title: {
            CZ: 'S růžemi',
            SK: 'S ružami'
        },
        image: 'krabicka-den-matek',
        thumb: 'krabicka-den-matek-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard']
    },
    {
        id: '11',
        country: ['CZ', 'SK'],
        title: {
            CZ: 'Vánoční větvičky',
            SK: 'Vánoční větvičky'
        },
        image: 'vanocni-s-vetvickami',
        thumb: 'vanocni-s-vetvickami-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard']
    },
    {
        country: ['CZ', 'SK'],
        id: '17',
        title: {
            CZ: 'České Vánoce',
            SK: 'Tradičné Vianoce'
        },
        image: 'krabicka-ceske-vanoce',
        thumb: 'krabicka-ceske-vanoce-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard']
    },
    {
        country: ['CZ', 'SK'],
        id: '18',
        title: {
            CZ: 'Modrá zima',
            SK: 'Modrá zima'
        },
        image: 'krabicka-zimni',
        thumb: 'krabicka-zimni-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard']
    },
    {
        country: ['CZ', 'SK'],
        id: '19',
        title: {
            CZ: 'Štědrý večer',
            SK: 'Štedrý večer'
        },
        image: 'krabicka-cesta',
        thumb: 'krabicka-cesta-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard', 'large']
    },
    {
        country: ['CZ', 'SK'],
        id: '22',
        title: {
            CZ: 'Krabička Spolu',
            SK: 'Krabička Spolu'
        },
        image: 'krabicka-spolu',
        thumb: 'krabicka-spolu-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard']
    },
    {
        country: ['CZ', 'SK'],
        id: '12',
        title: {
            CZ: 'Vánoční nálada',
            SK: 'Vianočná nálada'
        },
        image: 'vanocni-nalada',
        thumb: 'vanocni-nalada-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard', 'large']
    },
    {
        country: ['CZ', 'SK'],
        id: '9',
        title: {
            CZ: 'Vánoční krabička',
            SK: 'Vianočná krabička'
        },
        image: 'vanocni-krabicka',
        thumb: 'vanocni-krabicka-thumb',
        price: BASE_BOX_PRICE,
        size: ['standard', 'large']
    }
];

export const deliveryTypes = [
    {
        country: ['CZ'],
        title: {
            CZ: 'Osobní odběr v Zásilkovně',
            SK: 'Osobný odber v Zásielkovni'
        },
        id: 'zasilkovna',
        priceVat: {
            CZK: 49,
            EUR: 3
        },
        isBadge: true,
        isFreeShipping: true
    },
    /*   {
        country: ['CZ'],
        title: {
            CZ: 'Česká pošta',
            SK: 'Česká pošta'
        },
        id: 'delivery-cp',

        priceVat: {
            CZK: 99,
            EUR: 5
        },
        isFreeShipping: true
    },*/
    {
        country: ['CZ'],
        title: {
            CZ: 'Kurýr DPD Private (express)',
            SK: 'Kuriér DPD Private'
        },
        id: 'delivery',

        priceVat: {
            CZK: 99,
            EUR: 5
        },
        isFreeShipping: false
    },
    /*  {
        country: ['CZ'],
        title: {
            CZ: 'Nejlevnější doručení na adresu',
            SK: 'Nejlevnější doručení na adresu'
        },
        id: 'delivery-eco',

        priceVat: {
            CZK: 85,
            EUR: 4
        },
        isFreeShipping: true
    },*/

    {
        country: ['SK'],
        title: {
            CZ: 'Osobní odběr v Zásilkovně SK',
            SK: 'Osobný odber v Zásielkovne'
        },

        id: 'zasilkovna-sk',
        price: 63.8,
        priceVat: {
            CZK: 77,
            EUR: 3
        },
        isBadge: true,
        isFreeShipping: true
    },
    {
        country: ['SK'],
        title: {
            CZ: 'Slovenská pošta',
            SK: 'Prepravná služba'
        },
        id: 'delivery-sk',
        priceVat: {
            CZK: 128,
            EUR: 5
        },
        isFreeShipping: true
    },
    {
        country: ['HU'],
        title: {
            CZ: 'Kurýr DPD',
            SK: 'Kuriér DPD'
        },
        id: 'delivery-hu',
        priceVat: {
            CZK: 128,
            EUR: 5
        },
        isFreeShipping: true
    },
    {
        country: ['PL'],
        title: {
            CZ: 'Kurýr DPD',
            SK: 'Kuriér DPD'
        },
        id: 'delivery-pl',
        priceVat: {
            CZK: 128,
            EUR: 5
        },
        isFreeShipping: true
    },
    {
        country: ['DE'],
        title: {
            CZ: 'Německá pošta',
            SK: 'Nemecká pošta'
        },
        id: 'delivery-de',
        priceVat: {
            CZK: 128,
            EUR: 5
        },
        isFreeShipping: true
    },
    {
        country: ['AT'],
        title: {
            CZ: 'Rakouská pošta',
            SK: 'Rakúska pošta'
        },
        id: 'delivery-at',
        priceVat: {
            CZK: 138,
            EUR: 5.5
        },
        isFreeShipping: true
    }
    /* {
        country: ['UK'],
        title: {
            CZ: 'Royal mail',
            SK: 'Royal mail'
        },
        id: 'delivery-uk',
        priceVat: {
            CZK: 188,
            EUR: 7
        },
        isFreeShipping: true
    }*/
];

export function getDeliveryTypes(country, currency, deliveryCountry) {
    const ctr = deliveryCountry ? deliveryCountry : country;

    return deliveryTypes.map(type => {
        if (type.country.indexOf(ctr) > -1) {
            return {
                title: type.title[country],
                id: type.id,
                priceVat: type.priceVat[currency],
                isFreeShipping: type.isFreeShipping
            };
        }
    });
}

export const deliveryCountries = [
    {
        value: 'CZ',
        label: {
            CZ: 'Česká republika',
            SK: 'Česká republika'
        }
    },
    {
        value: 'SK',
        label: {
            CZ: 'Slovensko',
            SK: 'Slovensko'
        }
    },
    {
        value: 'HU',
        label: {
            CZ: 'Maďarsko',
            SK: 'Maďarsko'
        }
    },
    {
        value: 'DE',
        label: {
            CZ: 'Německo',
            SK: 'Nemecko'
        }
    },
    {
        value: 'AT',
        label: {
            CZ: 'Rakousko',
            SK: 'Rakúsko'
        }
    },
    {
        value: 'PL',
        label: {
            CZ: 'Polsko',
            SK: 'Poľsko'
        }
    }
    /*  {
        value: 'UK',
        label: {
            CZ: 'Velká Británie',
            SK: 'Veľká Británia'
        }
    }*/
];

export function getDeliveryCountries(country) {
    return deliveryCountries.map(ctr => {
        return {
            label: ctr.label[country],
            value: ctr.value
        };
    });
}

export const CFG_ORDER_TYPES = [
    {
        slug: 'oblibene',
        title: 'Dle oblíbenosti'
    },

    {
        slug: 'nejlevnejsi',
        title: 'Od nejlevnějšího'
    },
    {
        slug: 'nejdrazsi',
        title: 'Od nejdražšího'
    },
    {
        slug: 'novinky',
        title: 'Od nejnovějšího'
    }
];

export const RECEIVER_FILTER = [
    'pro-manzelkupritelkyni',
    'pro-manzelapritele',
    'pro-maminku',
    'pro-tatinka',
    'pro-brachu',
    'pro-segru',
    'pro-kamosku',
    'pro-babicku',
    'pro-dedu',
    'pro-kolegu',
    'pro-kolegyni',
    'na-svatbu',
    'pro-firmy'
];

export const CATEGORIES = [
    'akce',
    'vanoce',
    'kosmetika',
    'slane-dobroty',
    'sladke-dobroty',
    'kava-a-caj',
    'alkohol',
    'hrnky-a-lahve',
    'doplnky-do-bytu',
    'papirnictvi',
    'neco-na-sebe',
    'deti'
];
